__turbopack_context__.v({
  "bounds": "range-slider-module__dFRMgG__bounds",
  "labelSep": "range-slider-module__dFRMgG__labelSep",
  "labelValue": "range-slider-module__dFRMgG__labelValue",
  "labels": "range-slider-module__dFRMgG__labels",
  "rangeSlider": "range-slider-module__dFRMgG__rangeSlider",
  "thumb": "range-slider-module__dFRMgG__thumb",
  "thumbActive": "range-slider-module__dFRMgG__thumbActive",
  "track": "range-slider-module__dFRMgG__track",
  "trackBg": "range-slider-module__dFRMgG__trackBg",
  "trackFill": "range-slider-module__dFRMgG__trackFill",
});
